const pop_up_btn = document.querySelector(".btn_trailer");
const popOverlay = document.querySelector(".popOverlay");
const popContainer = document.querySelector(".popContainer");
const closeBtn = document.querySelector(".closeBtn");
const body = document.querySelector(".template-page-course");

pop_up_btn.addEventListener("click", function () {
  popOverlay.classList.add("active");
  popContainer.classList.add("active");
  body.classList.add("noScroll");
});

function closePopup() {
  popOverlay.classList.remove("active");
  popContainer.classList.remove("active");
  body.classList.remove("noScroll");

  const iframe = popContainer.querySelector("iframe");
  if (iframe) {
    const src = iframe.getAttribute("src").split("?")[0]; // Strip autoplay or extra params
    iframe.setAttribute("src", src);
  }
}

popOverlay.addEventListener("click", closePopup);
closeBtn.addEventListener("click", closePopup);
